<h5 class="titulo">Acompanhamento de rotinas batch de honra</h5>

<div class="container">
  <div class="row">
    <div class="col">
      <h3>Filtro de pesquisa</h3>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
    </div>

    <div class="col-auto">
      <button [disabled]="!nomeJanela" #focusableSubmit type="button" class="btn btn-success no-margin" (click)="buscarTodos()">
        Pesquisar
      </button>
    </div>
  </div>

  <div class="row">

    <div class="col-md-3">
      <label for="nomeJanela">Janela de envio: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Nome da janela de envio em formato Mês/Ano (MM/AAAA)"></i></label>
      <input type="text" class="form-control" bnMask="MESANO" [(ngModel)]="nomeJanela">
    </div>
  </div>
  <br>
  <p><ngb-progressbar *ngIf="pesquisado && (controleAgendamentoProcessoHonraBatch && controleAgendamentoProcessoHonraBatch.length)" type="info" [value]="progresso" height="20px">{{progresso}}%</ngb-progressbar></p> 
</div>

<app-acompanhamento-batch-listagem
  [controleAgendamentoProcessoHonraBatch]="controleAgendamentoProcessoHonraBatch"
  *ngIf="pesquisado"
  >
</app-acompanhamento-batch-listagem>


